import React, {useEffect, useState} from 'react';
import {
    Dialog, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import CloseButton from "../../../../../components/buttons/CloseButton";

export type RegistrationDialogProps = {
    open: boolean;
    onClose: () => void;
};

// 倒计时
let secondsInterval: NodeJS.Timeout;

const RegistrationDialog: React.FC<RegistrationDialogProps> = (props) => {

    const [seconds, setSeconds] = useState(10);

    useEffect(() => {
        if (props.open) {
            setSeconds(10);
            secondsInterval = setInterval(() => {
                setSeconds(seconds => seconds - 1);
            }, 1000);
            // 画面退出销毁倒计时
            return () => {
                if (secondsInterval) {
                    clearInterval(secondsInterval);
                }
            }
        }
    }, [props.open]);

    useEffect(() => {
        if (seconds <= 0) {
            clearInterval(secondsInterval);
            props.onClose();
        }
    }, [seconds])

    const handleClose = () => {
        props.onClose();
    }

    return (
        <Dialog open={props.open} onClose={() => handleClose()}>
            <DialogTitle>{seconds}S</DialogTitle>
            <DialogContent>
                <img alt={'Registration'} src={'/mobile_qrcode.png'}/>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={handleClose}/>
            </DialogActions>
        </Dialog>
    );
};

export default RegistrationDialog;
